import { hideLoader, showLoader } from '../../globalFunctions';
import { prkModalConfigs } from '../../common/hashed-links-handlers';
import { loadGrecaptcha } from '../../async/loadGrecaptcha.js';
import { getRecaptchaV3PublicKey } from "../../captcha";

const loadModal = async function () {
    const isModalLoaded = this.modal.classList.contains('loaded');
    if (isModalLoaded) {
        return;
    }

    showLoader($(this.modal));

    const getRecaptchaAttributes = (action) => {
        return new Promise((resolve, reject) => {
            loadGrecaptcha()
                .then(() => {
                    /** @var {Object} grecaptcha */
                    window.grecaptcha.ready(() => {
                        window.grecaptcha.execute(getRecaptchaV3PublicKey(), { action })
                            .then((token) => {
                                resolve({ tokenV3: token, actionV3: action });
                            })
                            .catch(reject)
                    })

                })
                .catch(reject);
        });
    }

    /**
     * @param {HTMLFormElement} form
     * @returns {Promise<*>}
     */
    const onSubmitForm = async (form) => {
        const formData = new FormData(form);

        showLoader($(form));

        let attributes = {};

        try {
            attributes = await getRecaptchaAttributes(form.id);
        } catch (e) {
            this.close();
            showMessage('Не удалось загрузить reCAPTCHA. Попробуйте, пожалуйста, позже.');
            return;
        }

        formData.append('token_v3', attributes.tokenV3);
        formData.append('action_v3', attributes.actionV3);

        return fetch(form.action, { method: 'POST', body: formData })
            .then((response) => response.json())
            .then(() => {
                form.innerHTML = `
                    <div class="product-question-form__header">
                        <button data-prk-modal-action="close" class="prk-modal-close-button" type="button">
                            <svg class="pi pi-close"><use xlink:href="#close"></use></svg>
                        </button>
                        <div class="product-question-form__title">Спасибо за ваш вопрос!</div>
                    </div>
                `;
            })
            .catch(() => {
                this.close();
                showMessage('Не удалось загрузить данные. Попробуйте, пожалуйста, позже.');
            })
            .finally(() => hideLoader($(form)));
    };

    const initCharsCounter = (textarea, counter) => {
        if (!textarea || !counter) {
            return;
        }

        textarea.addEventListener('input', (e) => {
            const size = e?.target?.value?.length ?? 0;

            if (size < textarea.minLength) {
                textarea.classList.add('product-question-form__field--invalid');
            } else {
                textarea.classList.remove('product-question-form__field--invalid');
            }
            counter.innerText = size;
        });
    };

    fetch(`/include/catalog/product/add-question/?product_id=${this.modal.dataset.productId || ''}`)
        .then((response) => response.text())
        .then((modalContent) => {
            this.modal.innerHTML = modalContent;
            this.modal.classList.add('loaded');

            const form = this.modal.querySelector('form');
            if (form) {
                form.addEventListener('submit', (e) => {
                    e.preventDefault();
                    onSubmitForm(form);
                });

                initCharsCounter(
                    form.querySelector('textarea'),
                    form.querySelector('.product-question-form__symbols-counter')
                );
            }
        })
        .finally(() => hideLoader($(this.modal)));
};

prkModalConfigs['add_question'] = { onOpen: loadModal };

const initProductQuestions = () => {
    const container = document.getElementById('product-questions');
    if (!container) {
        return;
    }

    const querySelectorHTMLString = (html, querySelector) => {
        const div = document.createElement('div');
        div.innerHTML = html.trim();
        return div.querySelector(querySelector);
    }

    const initLoadingMoreQuestions = (button) => {
        if (!button) {
            return;
        }

        const requestNextBatch = () => {
            const { productId, pageSize, currentPage, totalPages } = button.dataset;

            const pageToLoad = Number(currentPage) + 1;

            showLoader();
            fetch(`/api/prk/catalog/product/questions/?product_id=${productId}&page=${pageToLoad}&size=${pageSize}`)
                .then((response) => response.json())
                .then((data) => {
                    if (!data || !data.html) {
                        throw new Error('Content has not been sent');
                    }

                    return data.html;
                })
                .then((html) => {
                    const nodes =
                        querySelectorHTMLString(html, '.product-questions__list')?.childNodes ?? [];

                    const list = container.querySelector('.product-questions__list');
                    if (list) {
                        list.append(...nodes);
                    }

                    if (pageToLoad >= totalPages) {
                        button.hidden = true;
                    }

                    button.dataset.currentPage = pageToLoad;
                })
                .catch(() => {
                    showMessage('Не удалось загрузить данные. Попробуйте, пожалуйста, позже.');
                })
                .finally(hideLoader)
        }

        button.addEventListener('click', requestNextBatch);
    }

    initLoadingMoreQuestions(
        container.querySelector('.product-questions__load-more-button')
    );
}

export {
    initProductQuestions
};